var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 21,
    viewBox: "0 0 33 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 18955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Horizontal Divider"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_553_17748",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0996H33V11.0996H0V10.0996Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.0996H33V9.09961H0V11.0996Z",
    fill: "white",
    mask: "url(#path-1-inside-1_553_17748)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Border"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_553_17748",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 10.5996L23.1924 20.4072L13.3848 10.5996L23.1924 0.792034L33 10.5996Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33 10.5996L33.7071 11.3067L34.4142 10.5996L33.7071 9.8925L33 10.5996ZM32.2929 9.8925L22.4853 19.7001L23.8995 21.1143L33.7071 11.3067L32.2929 9.8925ZM22.4853 1.49914L32.2929 11.3067L33.7071 9.8925L23.8995 0.0849269L22.4853 1.49914Z",
    fill: "white",
    mask: "url(#path-3-inside-2_553_17748)"
  })))));
};
export default SvgArrow;